import { getZoneFromSite, siteNames } from '@seek/melways-sites';
import { Brand, Product } from '../../types.js';
export default {
    audience: 'https://seek/api/candidate',
    authDomain: 'login.staging.seek.com',
    clientDomain: 'my.staging.jobstreet.com',
    clientId: 'W3QCjijNF5QVnvtSf67vAiqGRoih6e9E',
    environment: 'dev',
    redirectPath: '/oauth/callback/',
    realm: 'Username-Password-Authentication',
    brand: Brand.JOBSTREET,
    contactUs: {
        en: 'https://my.jobstreet.com/contact-us/',
    },
    siteName: siteNames.candidate.jobstreet.my,
    zone: getZoneFromSite(siteNames.candidate.jobstreet.my),
    product: Product.SEEK,
};
//# sourceMappingURL=my_staging_jobstreet_com.js.map